import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

function DataDisplay({ apiEndpoint }) {
  const [data, setData] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiEndpoint);
        setData(response.data);
      } catch (err) {
        setError('Failed to fetch data');
      }
    };

    fetchData();
  }, [apiEndpoint]);

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div>
      <h4>Data from {apiEndpoint}</h4>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}

DataDisplay.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
};

export default DataDisplay;
